<orbit-dialog-header [title]="data.title" />

<div class="dialog-content">
  <form [formGroup]="data.form" class="webhook-form">
    <div class="form-group">
      <label for="endpointUrl">{{ 'SETTINGS.WEBHOOKS.ENDPOINT_URL' | translate }}</label>
      <input
        id="endpointUrl"
        type="text"
        formControlName="endpointUrl"
        [placeholder]="'SETTINGS.WEBHOOKS.URL_PLACEHOLDER' | translate">

      <div *ngIf="data.form.controls?.['endpointUrl'].invalid && data.form.controls?.['endpointUrl'].touched" class="error-message">
            <span *ngIf="data.form.controls?.['endpointUrl'].errors?.['pattern']">
              {{ 'SETTINGS.WEBHOOKS.INVALID_URL' | translate }}
            </span>
      </div>
    </div>
  </form>
</div>

<orbit-dialog-footer>
  <div class="right-addon" right-addon>
    <orbit-button
      [flat]="true"
      [disabled]="false"
      [label]="data.cancelLabel"
      (onClick)="closeDialog(false)">
    </orbit-button>
    <orbit-button
      [disabled]="data.form.invalid"
      [label]="data.confirmLabel"
      (onClick)="closeDialog(true)">
    </orbit-button>
  </div>
</orbit-dialog-footer>
